module.exports = {"520203001":"九龙街道","520203002":"银壶街道","520203003":"塔山街道","520203102":"岩脚镇","520203103":"木岗镇","520203104":"大用镇","520203105":"关寨镇","520203106":"牂牁镇","520203107":"新华镇","520203108":"龙河镇","520203109":"新窑镇","520203110":"郎岱镇","520203203":"梭戛苗族彝族回族乡","520203204":"牛场苗族彝族乡","520203205":"新场乡","520203208":"中寨苗族彝族布依族乡","520203213":"落别布依族彝族乡","520203214":"月亮河彝族布依族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520203.json
// module id = 2272
// module chunks = 0